import React from 'react';
import GenericDialogue from 'src/components/Dialogue/Dialogue';
import OpenContactLink from 'src/components/OpenContactLink/OpenContactLink';
import SelectedContactCard from '../ContactPicker/components/SelectedContactCard';
import { Subscriber } from './CustomHooks/useServiceRequestSubscribers';
import './SubscribersViewAllDialog.scss';

interface SubscribersViewAllDialogProps {
  isOpen: boolean;
  subscribers: Subscriber[];
  serviceRequestId: string;
  onClose: () => void;
}

const buildAvatarBadge = (
  role: string
): 'service-provider' | 'property-manager' => {
  if (role === 'Service Provider' || role === 'Service Manager') {
    return 'service-provider';
  }

  return 'property-manager';
};

const SubscribersViewAllDialog = ({
  isOpen,
  subscribers,
  serviceRequestId,
  onClose,
}: SubscribersViewAllDialogProps) => {
  return (
    <GenericDialogue
      isOpen={isOpen}
      onClose={onClose}
      title={`Subscribers (${subscribers.length})`}
      description="All users subscribed to email notifications for this service request."
      maxWidth="70rem"
    >
      <div className="subscribers-view-all-list">
        {subscribers.map((sub: Subscriber) => (
          <div key={sub.userId} className="subscribers-view-all-row">
            <SelectedContactCard
              name={sub.name}
              role={sub.role}
              profileImage={null}
              badge={buildAvatarBadge(sub.role)}
            />
            <OpenContactLink
              userId={sub.userId}
              name={sub.name}
              navOrigin={{ kind: 'serviceRequest', serviceRequestId }}
            />
          </div>
        ))}
      </div>
    </GenericDialogue>
  );
};

export default SubscribersViewAllDialog;
